module.exports = __webpack_public_path__ + "static/img/aolinteyaoye.3cd1d994.png";